import React from 'react';
import './Analysevibratoireservice.css';
import vibrationImage from '../Assets/analysevibratoire12.PNG'; // Vérifiez le chemin
import machineImage from '../Assets/Analysevibratoire13.PNG'; // Vérifiez le chemin
import anomalyImage from '../Assets/analysevibratoire1333.PNG'; // Vérifiez le chemin

const Analysevibratoireservice = () => {
  console.log('Rendering Analysevibratoireservice component');
  console.log('vibrationImage:', vibrationImage);
  console.log('machineImage:', machineImage);
  console.log('anomalyImage:', anomalyImage);

  return (
    <div className="analyse-container">
      <div className="intro-section">
        <h1>Analyse Vibratoire</h1>
        <p>
          Nous réalisons un service d’analyse vibratoire pour détecter et diagnostiquer précocement les anomalies mécaniques (déséquilibre, désalignement, usure de roulements), afin d’optimiser la fiabilité et la disponibilité de vos machines industrielles.
        </p>
      </div>
      <div className="image-grid">
        <div className="image-card">
          <img src={vibrationImage} alt="Analyse vibratoire" className="card-image" />
          <div className="card-content">
            <h2>Détection Précoce</h2>
            <p>Identifiez les problèmes avant qu'ils ne causent des pannes majeures.</p>
          </div>
        </div>
        <div className="image-card">
          <img src={machineImage} alt="Fiabilité des machines" className="card-image" />
          <div className="card-content">
            <h2>Fiabilité Optimale</h2>
            <p>Améliorez la disponibilité de vos équipements grâce à nos analyses.</p>
          </div>
        </div>
        <div className="image-card">
          <img src={anomalyImage} alt="Détection d'anomalies" className="card-image" />
          <div className="card-content">
            <h2>Diagnostic Précis</h2>
            <p>Diagnostiquez les déséquilibres et désalignements avec précision.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analysevibratoireservice;